import $ from 'jquery';
import { getState } from '~src/state';
import { loadSelectTagsBackground } from '~src/sidebar/index';
import { isLoggedUserGlobalEditor } from '~src/user';
import { EdgeResizer, checkUserOwnership } from '~src/utils';

export const displayBackgroundManager = async (backgroundItemId) => {
  const currentTag = getState('sidebarCurrentBackgroundsTag', 'NO_TAG');
  const isGlobalEditor = await isLoggedUserGlobalEditor();
  let defaultBackground = false;

  const backgroundItem = window.editorConfig.sidebarBackgrounds[
    currentTag
  ].items.find((item) => item.objectId === backgroundItemId);
  const isUserOwner = await checkUserOwnership(backgroundItem);

  if (backgroundItem.isGlobal) {
    defaultBackground = true;
  }

  $('#selectFormat-background-container').empty();
  $('#selectTag-background-container').empty();
  $('#tag-background-container').empty();

  if (!$(`#tag-preview-background-${backgroundItem.objectId}`).length) {
    const previewImg = new EdgeResizer(backgroundItem.file.url).scaleToWidth(
      200
    );

    const descriptionHtml = `
    <div id="tag-preview-background-${backgroundItem.objectId}" class="items-tag-image-container">
      <img src="../assets/svg/img-loader.gif" class="lazy items-tag-image" data-src="${previewImg}" />
    </div>
    <div class="tag-preview-background-container-description">
      <div class="tag-preview-background-container-description-title">
        Dimensioni:
      </div>
      <div class="tag-preview-background-container-description-text">
        Altezza: ${backgroundItem.height} px - Larghezza: ${backgroundItem.width} px
      </div>
    </div>
      `;
    $('#tag-background-container').html(descriptionHtml);
    window.lazyLoadInstance.update();
  }

  let tagsHtml = '';
  if (backgroundItem.tags.length > 0) {
    backgroundItem.tags.forEach((item) => {
      tagsHtml += `
      <a
        id="btn-menu-frames"
        class="btn px-3 buttonBoxIcon"
        nohref
        role="button"
      >
        #${item.name}`;
      if (isGlobalEditor || isUserOwner) {
        tagsHtml += `
          <div
            id="delete-tag-${item.objectId}"
            data-delete-background-id="${backgroundItem.objectId}"
            data-delete-background-tag-id="${item.objectId}"
            data-delete-background-tag-status="${defaultBackground}"
            class="buttonSvg editor-tag-delete"
          />
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width="20" height="20" fill="currentColor">
              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
            </svg> 
        </div>
          <div
              id="editor-btn-spinner-${item.objectId}"
              class="spinner-grow spinner-grow-sm text-light"
              role="status"
              style="display: none;"
            >
          </div>`;
      }
      tagsHtml += '</a>';
    });
  }
  $('#tags-background-container').html(tagsHtml);

  if (isGlobalEditor || isUserOwner) {
    let selectTagsHtml = `
    <div id="tag-select-background">
      <select id="tagBackgroundSelect" multiple="multiple"></select>
    </div>
        <button class="buttonSidebarSaveTags" data-save-background-tag-status="${defaultBackground}" data-save-tag-background-id="${backgroundItem.objectId}" id="saveNewTags">
          Salva
          <div
            id="editor-btn-spinner"
            class="spinner-grow spinner-grow-sm text-light"
            role="status"
            style="display: none;"
          >
          </div>
        </button>`;
    $('#selectTag-background-container').html(selectTagsHtml);
    loadSelectTagsBackground(backgroundItemId);
  }
};
